import React from 'react';
import { Input } from 'reactstrap';
import './SingleSelect.css';

const SingleSelect = ({
  id,
  disabled,
  required,
  name,
  value,
  onChange,
  defaultOptLabel,
  options,
  ...props
}) => {
  return (
    <Input
      type='select'
      id={id || ''}
      disabled={disabled || false}
      required={required || false}
      name={name}
      value={value || ''}
      onChange={onChange}
    >
      <option value={''}>{defaultOptLabel || 'Select'}</option>
      {options &&
        options.map((elem, index) => {
          return (
            <option key={`${index}-${name || 'select'}`} value={elem[props.selectedValueKey || "value"]}>{elem[props.label || "label"]} {props.labelSecond ? elem[props.labelSecond] : ''}</option>
          );
        })}
    </Input>
  );
};

export default SingleSelect;
